import React, { Component } from 'react'
import { Popup, Form } from 'devextreme-react'
import { confirm, alert } from 'devextreme/ui/dialog'
import httpRequest from 'plugin/httprequest'
import { showLoading } from 'redux/actions/loading'

class KlaimApproval extends Component {
  constructor(props) {
    super(props)

    this.state = {
      data: {},
    }

    this.show = this.show.bind(this)
    this.hide = this.hide.bind(this)

    this.formApproval = [
      {
        dataField: 'note',
        label: {
          text: 'Catatan',
        },
        editorType: 'dxTextArea',
        editorOptions: {
          elementAttr: {
            class: 'bd-input-popup-dapen-default',
            style: 'height: 120px !important',
          },
        },
      },
    ]

    this.PopupToolbarItem = [
      {
        widget: 'dxButton',
        location: 'after',
        options: {
          text: 'Simpan',
          elementAttr: { class: 'bg-button-popup-save-dapen-default' },
          onClick: async () => {
            let confirms = await confirm(
              'Apakah anda ingin menyimpan data ini ?',
              'Konfirmasi'
            )
            if (confirms) {
              await this.approve()
            }
          },
        },
        toolbar: 'bottom',
      },
      {
        widget: 'dxButton',
        location: 'after',
        options: {
          text: 'Batal',
          elementAttr: { class: 'bg-button-popup-close-dapen-default' },
          onClick: this.hide.bind(this),
        },
        toolbar: 'bottom',
      },
    ]
  }

  show = (klaimId) => {
    this.setState({
      popupVisible: true,
      data: {
        klaimId: klaimId,
      },
    })
  }

  hide = () => {
    this.setState({
      data: {},
      popupVisible: false,
    })
  }

  approve = async () => {
    let param = this.state.data

    this.props.store.dispatch(showLoading(true))
    try {
      await httpRequest(
        process.env.REACT_APP_BACKEND_CORE,
        this.props.store,
        `wp/approve-klaim/${param.klaimId}?isApprove=${
          this.props.type === 'approve' ? true : false
        }`,
        'POST',
        {
          values: param.note,
        }
      )

      this.props.store.dispatch(showLoading(false))
      let result = await alert(
        `Data Berhasil ${
          this.props.type === 'approve' ? 'Disetujui' : 'Ditolak'
        }`,
        'Berhasil'
      )
      if (result) {
        this.hide()
        this.props.forceRefresh()
      }
    } catch (e) {
      console.error(e)
      this.props.store.dispatch(showLoading(false))
      alert(`Terjadi Kesahalahan`, 'Error')
    }
  }

  render() {
    return (
      <Popup
        className={'popup'}
        visible={this.state.popupVisible}
        onHiding={this.hide}
        dragEnabled={false}
        showTitle={true}
        title={`${
          this.props.type === 'approve' ? 'Pesetujuan' : 'Penolakan'
        } Klaim Peserta Pemberi Kerja`}
        width={500}
        height={'auto'}
        toolbarItems={this.PopupToolbarItem}
        ref={this.PopupRef}
      >
        <Form
          ref={this.formRef}
          colCount={1}
          id={'klaimApproval'}
          formData={this.state.data}
          items={this.formApproval}
          // labelLocation="left"
        />
      </Popup>
    )
  }
}

export default KlaimApproval
